import Cookie from 'js-cookie'
import { useEffect, useRef, useState } from 'react'

export const useCookies = () => {
  const ref = useRef(document.cookie)
  const [cookies, setCookies] = useState(() => Cookie.get())

  useEffect(() => {
    const i = setInterval(() => {
      if (ref.current !== document.cookie) {
        ref.current = document.cookie
        setCookies(Cookie.get())
      }
    }, 1000)

    return () => {
      clearInterval(i)
    }
  }, [])

  return cookies
}
